import vuex from "@/store";

/**
 * 获取格式化后的时间
 * @param stamp 时间戳
 * @returns {`${number}-${number}-${number} ${number}:${number}:${number}`}
 */
export const get_formatting_time = function (stamp = null) {
  let data = new Date();
  if (typeof stamp === "number") {
    data = new Date(stamp * 1000);
  }
  return `${data.getFullYear()}-${
    data.getMonth() + 1
  }-${data.getDate()} ${data.getHours()}:${data.getMinutes()}:${data.getSeconds()}`;
};

/**
 * 用于生成uuid
 * @return {string}
 */
export const generateUUID = function () {
  let d = new Date().getTime();
  if (window.performance && typeof window.performance.now === "function") {
    d += performance.now();
  }
  const uuid = "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(
    /[xy]/g,
    function (c) {
      var r = (d + Math.random() * 16) % 16 | 0;
      d = Math.floor(d / 16);
      return (c === "x" ? r : (r & 0x3) | 0x8).toString(16);
    }
  );
  return uuid;
};

/**
 * 返回cookies
 * @returns {{}}
 */
export const get_cookies = function () {
  let temp = {};
  if (document.cookie !== "") {
    document.cookie.split("; ").forEach((item) => {
      temp[item.split("=")[0]] = item.split("=")[1];
    });
  }
  return temp;
};

/**
 * ocr结果脱敏
 * @param{string} text ocr结果
 */
export const stealing_sensitive_ocr = function (text) {
  const stealing_sensitive = [
    {
      re: /姓名([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "姓名：** ",
    },
    {
      re: /刘福军([： :\f\r\s\t]*)([\u4e00-\u9fa5]{3})/g,
      text: "***",
    },
    {
      re: /报告录入员([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "报告录入员：** ",
    },
    {
      re: /检验目的([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "检验目的：**",
    },
    {
      re: /申请医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "申请医生：**",
    },
    {
      re: /住院号([：:\f\r\s\t]*)([\u4e00-\u9fa5]{4})/g,
      text: "住院号：****",
    },
    {
      re: /样本编号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "样本编号：****",
    },
    {
      re: /样本号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "样本号：****",
    },
    {
      re: /门诊编号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "门诊编号：**** ",
    },
    {
      re: /门诊号码([：:\f\r\s\t]*)([\d]{4})/g,
      text: "门诊号码：**** ",
    },
    {
      re: /门诊号([：: \f\r\s\t]*)([\d]{ 4})/g,
      text: "门诊号：**** ",
    },
    {
      re: /门诊号([：:\f\r\s\t]*)([\u4e00-\u9fa5]{4})/g,
      text: "门诊号：**** ",
    },
    {
      re: /门诊号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "门诊号：**** ",
    },
    {
      re: /门诊([：:\f\r\s\t]*)([\d]{4})/g,
      text: "门诊：****",
    },
    {
      re: /门诊([：: \f\r\s\t] *)([\d]{ 4})/g,
      text: "门诊：****",
    },
    {
      re: /条码号([：:\f\r\s\t]*)([\u4e00-\u9fa5]{4})/g,
      text: "条码号：****",
    },
    {
      re: /病案号([：:\f\r\s\t]*)([\u4e00-\u9fa5]{4})/g,
      text: "病案号：****",
    },
    {
      re: /标本编号([：:\f\r\s\t]*)([\d]{6})/g,
      text: "标本编号：******",
    },
    {
      re: /标本号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "标本号：**** ",
    },
    {
      re: /标本号([：:\f\r\s\t]*)([\d]{3})/g,
      text: "标本号：**** ",
    },
    {
      re: /标本号([：:\f\r\s\t]*)([\d]{2})/g,
      text: "标本号：*** ",
    },
    {
      re: /标本：([:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "标本：**",
    },
    {
      re: /(.{2})\s*(大学)/g,
      text: "**大学",
    },
    {
      re: /(.{3})\s*(大学)/g,
      text: "***大学",
    },
    {
      re: /([\u4e00-\u9fa5]{4})卫生院/g,
      text: "**** 卫生院",
    },
    {
      re: /([\u4e00-\u9fa5]{3})医院/g,
      text: "***医院",
    },
    {
      re: /([\u4e00-\u9fa5]{4})医院/g,
      text: "****医院",
    },
    {
      re: /([\u4e00-\u9fa5]{5})医院/g,
      text: "******医院",
    },
    {
      re: /([\u4e00-\u9fa5]{6})医院/g,
      text: "******医院",
    },
    {
      re: /送检医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检医生：**",
    },
    {
      re: /送检医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检医师：**",
    },
    {
      re: /条码号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "条码号：****",
    },
    {
      re: /超声号([：US:\f\r\s\t]*)([\d]{4})/g,
      text: "超声号：**** ",
    },
    {
      re: /超声号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "超声号：**** ",
    },
    {
      re: /超声号([：:\f\r\s\t]*)([w*[dA-Za-z]+w*]{4})/g,
      text: "超声号：**** ",
    },
    {
      re: /病历号([：:\f\r\s\t]*)([\d]{6})/g,
      text: "病历号：******",
    },
    {
      re: /病历号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病历号：******",
    },
    {
      re: /样本编号([：:\f\r\s\t]*)([w*[dA-Za-z]+w*]{4})/g,
      text: "样本编号：****",
    },
    {
      re: /标本各类([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "标本各类：**",
    },
    {
      re: /科室([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "科室：**",
    },
    {
      re: /患者类型([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "患者类型：**",
    },
    {
      re: /检测方法([：:\f\r\s\t]*)([[\u4e00-\u9fa5A-Za-z]+]{4})/g,
      text: "检测方法：****",
    },
    {
      re: /检测仪器([：:\f\r\s\t]*)([w*[dA-Za-z]+w*]{4})/g,
      text: "检测仪器：****",
    },
    {
      re: /送检材料([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检材料：**",
    },
    {
      re: /申请科室([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "申请科室：**",
    },
    {
      re: /申请医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "申请医生：**",
    },
    {
      re: /申请医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "申请医师：**",
    },
    {
      re: /就诊类型([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "就诊类型：**",
    },
    {
      re: /设备名称([：:\f\r\s\t]*)([[\u4e00-\u9fa5A-Za-z]+]{4})/g,
      text: "设备名称：****",
    },
    {
      re: /送检科室([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检科室：**",
    },
    {
      re: /送检医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检医师：**",
    },
    {
      re: /病人种类([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "病人种类：**",
    },
    {
      re: /就诊卡号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "就诊卡号：****",
    },
    {
      re: /检验项目([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "检验项目：**",
    },
    {
      re: /检验医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "检验医师：**",
    },
    {
      re: /审核医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "审核医师：**",
    },
    {
      re: /备注([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "备注：**",
    },
    {
      re: /接收人员([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "接收人员：**",
    },
    {
      re: /登记号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "登记号：****",
    },
    {
      re: /病床号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病床号：****",
    },
    {
      re: /类别([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "类别：**",
    },
    {
      re: /检查号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "检查号：****",
    },
    {
      re: /样本状态([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "样本状态：**",
    },
    {
      re: /诊断医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "诊断医生：**",
    },
    {
      re: /诊断医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "诊断医师：**",
    },
    {
      re: /诊断号([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "诊断号：**",
    },
    {
      re: /诊断([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "诊断：**",
    },
    {
      re: /流水号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "流水号：****",
    },
    {
      re: /检验医嘱([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "检验医嘱：**",
    },
    {
      re: /初步诊断([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "初步诊断：**",
    },
    {
      re: /条形码([：:\f\r\s\t]*)([\d]{4})/g,
      text: "条形码：****",
    },
    {
      re: /送检医院([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检医院：**",
    },
    {
      re: /送检科室([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检科室：**",
    },
    {
      re: /标本类型([：*:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "标本类型：*** ",
    },
    {
      re: /标本类型([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "标本类型：*** ",
    },
    {
      re: /科别([：:\f\r\s\t]*)([\u4e00-\u9fa5]{4})/g,
      text: "科别：****",
    },
    {
      re: /样本编号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "样本编号：****",
    },
    {
      re: /病区([：:\f\r\s\t]*)([\u4e00-\u9fa5]{6})/g,
      text: "病区：******",
    },
    {
      re: /送检医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检医生：**",
    },
    {
      re: /检验者([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "检验者：**",
    },
    {
      re: /审核者([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "审核者：**",
    },
    {
      re: /审核人([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "审核人：**",
    },
    {
      re: /批准人([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "批准人：**",
    },
    {
      re: /报告医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "报告医生：**",
    },
    {
      re: /审核医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "审核医生：**",
    },
    {
      re: /ID号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "ID号：**** ",
    },
    {
      re: /床号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "床号：****",
    },
    {
      re: /床号([：:\f\r\s\t]*)([\d]{2})/g,
      text: "床号：****",
    },
    {
      re: /病人类型([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "病人类型：**",
    },
    {
      re: /病员号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病员号：****",
    },
    {
      re: /申请单号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "申请单号：****",
    },
    {
      re: /科别([：:\f\r\s\t]*)([\d]{4})/g,
      text: "科别：****",
    },
    {
      re: /病案号([ ：:\f\r\s\t]*)([\d]{4})/g,
      text: "病案号：****",
    },
    {
      re: /审核医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "审核医师：**",
    },
    {
      re: /样本类型([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "样本类型：**",
    },
    {
      re: /费别([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "费别：**",
    },
    {
      re: /复检([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "复检：**",
    },
    {
      re: /病人ID([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病人ID：****",
    },
    {
      re: /报告医师([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "报告医师：**",
    },
    {
      re: /HIS号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "HIS号：****",
    },
    {
      re: /湛江久和医院([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "湛江久和医院：**",
    },
    {
      re: /住院号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "住院号：****",
    },
    {
      re: /病人ID号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病人ID号：****",
    },
    {
      re: /病人号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病人号：****",
    },
    {
      re: /住院([：: \f\r\s\t]*)([\d]{ 4})/g,
      text: "住院：****",
    },
    {
      re: /样本号([：:\f\r\s\t]*)([\d]{3})/g,
      text: "样本号：***",
    },
    {
      re: /样本号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "样本号：****",
    },
    {
      re: /住院号([：: \f\r\s\t] *)([\d]{ 4})/g,
      text: "住院号：****",
    },
    {
      re: /病床([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病床：****",
    },
    {
      re: /检验号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "检验号：****",
    },
    {
      re: /送检医院([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检医院：**",
    },
    {
      re: /送检科室([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "送检科室：**",
    },
    {
      re: /复诊医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "复诊医生：**",
    },
    {
      re: /病案([：:\f\r\s\t]*)([\d]{4})/g,
      text: "病案：****",
    },
    {
      re: /条码([：:\f\r\s\t]*)([\d]{4})/g,
      text: "条码：****",
    },
    {
      re: /初诊医生([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "初诊医生：**",
    },
    {
      re: /标识码([：:\f\r\s\t]*)([\d]{4})/g,
      text: "标识码：****",
    },
    {
      re: /申请项目([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "申请项目：**",
    },
    {
      re: /操作者([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "操作者：**",
    },
    {
      re: /检验员([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "检验员：**",
    },
    {
      re: /复核员([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "复核员：**",
    },
    {
      re: /(.{2})\s*(省)/g,
      text: "**省",
    },
    {
      re: /(.{2})\s*(市)/g,
      text: "**市",
    },
    {
      re: /(.{2})\s*(区)/g,
      text: "**区",
    },
    {
      re: /(.{2})\s*(路)/g,
      text: "**路",
    },
    {
      re: /(.{2})\s*(县)/g,
      text: "**县",
    },
    {
      re: /(.{2})\s*(学院)/g,
      text: "**学院",
    },
    {
      re: /[\d]{4}-([\d]{7})/g,
      text: "****-*******",
    },
    {
      re: /电话([：:\f\r\s\t]*)([\d]{4})/g,
      text: "电话：****",
    },
    {
      re: /手机([：:\f\r\s\t]*)([\d]{4})/g,
      text: "手机：****",
    },
    {
      re: /手机号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "手机号：****",
    },
    {
      re: /手机([：:\f\r\s\t]*)([\d]{8})/g,
      text: "手机：********",
    },
    {
      re: /床号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "床号：******",
    },
    {
      re: /CT号([：CT:\f\r\s\t]*)([\d]{4})/g,
      text: "CT号：***** ",
    },
    {
      re: /CT号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "CT号：***** ",
    },
    {
      re: /祥本编号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "祥本编号：****",
    },
    {
      re: /编号([：:\f\r\s\t]*)([\d]{4})/g,
      text: "编号：****",
    },
    {
      re: /([\f\r\s\t]*)([\d]{9})/g,
      text: "********",
    },
    {
      re: /检验者([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "检验者：** ",
    },
    {
      re: /审核者([：:\f\r\s\t ]*)([\d\u4e00-\u9fa5]{2})/g,
      text: "审核者：** ",
    },
    {
      re: /批准人([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "批准人：** ",
    },
    {
      re: /核对者([：:\f\r\s\t]*)([\u4e00-\u9fa5]{2})/g,
      text: "核对者：** ",
    },
    {
      re: /邹东/g,
      text: "**",
    },
    {
      re: /黄鸿/g,
      text: "**",
    },
    {
      re: /黄波/g,
      text: "**",
    },
  ];
  for (let i = 0; i < stealing_sensitive.length; i++) {
    text = text.replace(
      stealing_sensitive[i]["re"],
      stealing_sensitive[i]["text"]
    );
  }
  return text;
};

export const get_web_socket_base_url = function () {
  if (location.protocol === "https:") {
    return `wss://${location.host}/api`;
  }
  return `ws://127.0.0.1:8000`; //`ws://${location.host}`
  // return `wss://dxai.xsmartanalysis.com/api`; //`ws://${location.host}`
};

export const del_cookie = function (name) {
  /**
   * 删除指定cookie
   * @type {string}
   */
  document.cookie = `${name}=false;expires=` + new Date(0).toUTCString();
};

export const clear_cookie = function () {
  /**
   * 清空cookie
   */
  const cookies = get_cookies();
  for (const key in cookies) {
    del_cookie(key);
  }
};
/**
 * 获取模型使用状态
 * @returns {boolean}
 */
export const get_use_state = function () {
  if (vuex.state.chat.chat_index !== -1) {
    const record =
      vuex.state.chat.chat_record[vuex.state.chat.chat_index].record;
    for (const recordKey in record) {
      const messages =
        vuex.state.chat.chat_record[vuex.state.chat.chat_index].record[
          recordKey
        ];
      if (!messages[messages.length - 1].is_end && vuex.state.chat.is_resolve) {
        return true;
      }
    }
  }
  return false;
};
